import React, { Suspense } from "react";

const TalkPage = React.lazy(() => import("../view/Viewer.jsx"));

const Talk = () => {
  return (
    <Suspense fallback={null}>
      <TalkPage />
    </Suspense>
  );
};

export default Talk;
